import React, { useEffect, useMemo, useState } from "react";
import { Container, Paper, Typography, Button, Grid } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useParams, useLocation, Link } from "react-router-dom";
import ordersService from "../../services/orders.service";
import LightSection from "../../components/light-section";
import Loading from "../../components/loading";
import NotFoundPage from "../../components/404";
import RequestFailure from "./request-failure";
import FAIL_IMAGE from "../../assets/images/payment-failed.png";
import { currencyFormat } from "../../helpers";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      textAlign: "center",
      paddingTop: 64,
      paddingBottom: 64,
    },
    successIcon: {
      fontSize: 100,
      color: theme.palette.success.main,
    },
    img: {
      width: 400,
      maxWidth: "60%",
      boxShadow: "0 0 22px 27px #fff",
    },
    title: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(6),
    },
  })
);
function useQuery() {
  const entries = new URLSearchParams(useLocation().search).entries();
  return useMemo(() => {
    const res = {};
    for (let [key, value] of entries) {
      res[key] = value;
    }
    return res;
  }, [entries]);
}
export default function PaymentPage() {
  const classes = useStyles();
  const [waiting, setWaiting] = useState(true);
  const { status, token } = useQuery();
  const { field } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    if (+status !== 1) {
      setData("PaymentFailure");
      setWaiting(false);
      return;
    }
    setWaiting(true);
    switch (field) {
      case "order":
        ordersService
          .validatePayment(token)
          .then(({ data, error }) => {
            setWaiting(false);
            if (error) {
              setData("PaymentFailure");
              return;
            }
            setData(data);
          })
          .catch(() => {
            setData("RequestFailure");
            setWaiting(false);
          });
        break;
      default:
        setData("NotFound");
        setWaiting(false);
    }
  }, [field, status, token]);
  return (
    <Loading isLoading={waiting} fullPage>
      <Container>
        <LightSection noParent>
          <Grid justify="center" container>
            <Grid item xs={12} sm={8} md={6}>
              {data === "PaymentFailure" ? (
                <div className={classes.root}>
                  <img
                    className={classes.img}
                    src={FAIL_IMAGE}
                    alt="failed-transaction"
                  />
                  <Typography
                    className={classes.title}
                    component="h1"
                    variant="h3"
                    color="error"
                  >
                    پرداخت نا موفق
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    component="a"
                    href="optic://inakshop.com"
                  >
                    بازگشت به اپ
                  </Button>
                </div>
              ) : data === "RequestFailure" ? (
                <RequestFailure />
              ) : data === "NotFound" ? (
                <NotFoundPage />
              ) : data ? (
                <>
                  <div className={classes.root}>
                    <CheckCircleIcon className={classes.successIcon} />
                    <Typography
                      className={classes.title}
                      component="h1"
                      variant="h3"
                    >
                      پرداخت موفق
                    </Typography>
                    <Typography
                      className={classes.title}
                      component="h2"
                      variant="h6"
                    >
                      مبلغ: {currencyFormat(data.payableAmount)}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      component="a"
                      href={`optic://inakshop.com/profile/orders/${data.id}`}
                    >
                      بازگشت به اپ
                    </Button>
                  </div>
                </>
              ) : null}
            </Grid>
          </Grid>
        </LightSection>
      </Container>
    </Loading>
  );
}
